// Starting figures for the money target, until the backend field exists.
//
// Extracted so the overview mock and the target store can both use it without
// importing each other.
//
// The two exports retire on DIFFERENT tickets, so do not delete the file in one
// go: `getDefaultMoneyTarget` goes when REH-340 lands and the target arrives on
// the year plan payload, while `profileIndexFor` belongs to the overview mock and
// survives until REH-213 replaces it with a real endpoint.

const MONEY_TARGET = 16_000_000;

// Five buckets rather than three, mapped so the no-target state lands on roughly
// one location in five instead of one in three. Straight modulo over three
// profiles made the least interesting state the most common one.
const PROFILE_BUCKETS = [0, 1, 0, 1, 2];

// Stable per location and order-independent, so a location reads the same from
// the overview and from its own year plan.
export function profileIndexFor(locationId: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < locationId.length; i++) {
    // `?? 0` only satisfies the number | undefined return type: i is always
    // within the string here, so the fallback is unreachable.
    hash ^= locationId.codePointAt(i) ?? 0;
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return PROFILE_BUCKETS[hash % PROFILE_BUCKETS.length];
}

// Null for the bucket that demonstrates a location with no target set, which is
// also where scratch locations land.
export function getDefaultMoneyTarget(locationId: string): number | null {
  return profileIndexFor(locationId) === 2 ? null : MONEY_TARGET;
}
